"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhatExactlyIsARobotaxi() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="vad-är-egentligen-en-robotaxi" className="bg-background py-24">
      <div ref={ref} className={`max-w-7xl mx-auto px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground text-center mb-12 md:mb-16">
          Vad är egentligen en Robotaxi?
        </h2>

        <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-stretch">
          {}
          <div className="flex-1 text-foreground/80 leading-relaxed text-base md:text-lg">
            <p className="mb-4">
              En robotaxi är ett självkörande fordon som fungerar som en
              taxitjänst helt utan en mänsklig förare bakom ratten. Genom att
              kombinera avancerad mjukvara, artificiell intelligens och en rad
              olika sensorer kan dessa bilar navigera säkert i komplexa
              stadsmiljöer, identifiera hinder och följa trafikregler med hög
              precision.
            </p>
            <p>
              Företag som Tesla satsar stort på vision-baserade system med sin{" "}
              <strong className="text-primary font-semibold">
                Full Self-Driving
              </strong>
              -teknik, som förlitar sig på kameror och neurala nätverk. Andra
              aktörer som Waymo använder en kombination av kameror, radar och{" "}
              <strong className="text-primary font-semibold">Lidar</strong> för
              att skapa en extremt detaljerad 3D-karta av omgivningen i
              realtid.
            </p>
          </div>

          {}
          <Separator orientation="vertical" className="hidden md:block h-auto bg-border/60" />
          <Separator orientation="horizontal" className="md:hidden bg-border/60" />

          {}
          <div className="flex-1 text-foreground/80 leading-relaxed text-base md:text-lg">
            <p className="mb-4">
              Målet med robotaxis är att erbjuda en säkrare, billigare och mer
              tillgänglig transportlösning för alla. Genom att eliminera
              arbetskostnaden för en förare förväntas priset per resa sjunka
              drastiskt, vilket i förlängningen kan förändra hur vi ser på
              bilägande och stadsplanering i framtiden.
            </p>
            <p>
              I Sverige pågår just nu diskussioner om de juridiska ramverk som
              krävs för att tillåta helt autonoma fordon på våra vägar utan
              säkerhetsförare. Samtidigt utvecklas tekniken i en rasande fart,
              och det är inte längre en fråga om <em>om</em>, utan <em>när</em>{" "}
              denna framtidsvision blir en naturlig del av vår vardag.
            </p>
          </div>
        </div>
      </div>
    </section>;
}